<template>
  <div>
    <section class="container">
      <ul v-if="details != ''">
        <li class="disBlock">
          <h3>{{ details.name }}</h3>
        </li>
        <li class="disBlock">
          <label>手机号：</label>
          <p>{{ details.phone }}</p>
        </li>
        <li class="disBlock">
          <label>身份证号：</label>
          <p>{{ details.id_card }}</p>
        </li>
        <li class="disBlock">
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li class="disBlock">
          <label>日期：</label>
          <p>{{ details.month_date }}</p>
        </li>
        <li>
          <label>编号：</label>
          <p>{{ details.number }}</p>
        </li>
        <li>
          <label>出勤天数：</label>
          <p>{{ details.days }}</p>
        </li>
        <li>
          <label>订单总数：</label>
          <p>{{ details.order_count }}</p>
        </li>
        <li>
          <label>订单收入：</label>
          <p>{{ details.order_salary }}</p>
        </li>
        <li>
          <label>拉新：</label>
          <p>{{ details.new_salary }}</p>
        </li>
        <li>
          <label>保险：</label>
          <p>{{ Number(details.insure) + "元" }}</p>
        </li>
        <li>
          <label>系统预支：</label>
          <p>{{ Number(details.pre_amount) + "元" }}</p>
        </li>
        <li>
          <label>线下预支：</label>
          <p>{{ Number(details.advance) + "元" }}</p>
        </li>
        <li>
          <label>管理扣款：</label>
          <p>{{ Number(details.loan) + "元" }}</p>
        </li>
        <li>
          <label>应发：</label>
          <p>{{ Number(details.pre_provide) + "元" }}</p>
        </li>
        <li>
          <label>实发：</label>
          <p>{{ Number(details.provide) + "元" }}</p>
        </li>
        <li
          v-show="details.float_data_config != ''"
          v-for="(item, k) in details.float_data_config"
          :key="k"
        >
          <label>{{ item.name + "：" }}</label>
          <p>{{ item.value }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.details = this.detailsVal;
    }
    // console.log(this.detailsVal);
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.details = this.detailsVal;
      // console.log(this.detailsVal);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      margin-bottom: 10px;
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
    .disBlock {
      display: block;
    }
  }
}
</style>
